import { type ReactNode } from "react"
import { toast } from "react-toastify"

type ToastContentProps = {
  title: ReactNode
  description?: ReactNode
}

/**
 * Standardised toast body: medium-weight title + optional regular-weight description.
 * Use it whenever a toast needs a supporting line; a plain string stays title-only.
 *   toast.success(<ToastContent title="Saved" description="Your changes are live" />)
 * Canonical intent: {@link ~/components/design-system/intents TOAST_INTENT}.
 * Approved surface: design-system/APPROVED.md.
 */
export const ToastContent = ({ title, description }: ToastContentProps) => (
  <div className="flex flex-col">
    <p className="label-base text-fg-base">{title}</p>
    {description && <p className="paragraph-base text-fg-subtle">{description}</p>}
  </div>
)

const FormattedZodError = ({ message }: { message: string }) => {
  const withoutTitle = message.replace("Validation error: ", "")
  const multipleIssues = withoutTitle.split(";")

  return (
    <ToastContent
      title="Validation errors"
      description={
        <ul className="list-disc ml-4">
          {multipleIssues.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      }
    />
  )
}

export const showErrorToast = (error: any) => {
  if (error?.data?.inputValidationError) {
    toast.error(<FormattedZodError message={error?.data?.inputValidationError.message} />)
  } else {
    toast.error(<ToastContent title="Error" description={error.message} />)
  }
}
